export default "__VITE_ASSET__C5lK3$IL__"